import React, { useMemo } from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

const DEFAULT_MODULES = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ align: [] }],
    ['link'],
    ['clean'],
  ],
}

const DEFAULT_FORMATS = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'list',
  'bullet',
  'align',
  'link',
]

/**
 * WYSIWYG editor for CMS page content (Quill).
 */
function RichTextEditor({ value, onChange, id, placeholder }) {
  const modules = useMemo(() => DEFAULT_MODULES, [])
  const formats = useMemo(() => DEFAULT_FORMATS, [])

  return (
    <div className="manage-rte" id={id ? `${id}-wrap` : undefined}>
      <ReactQuill
        theme="snow"
        value={value || ''}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder || 'Write page content…'}
      />
    </div>
  )
}

export default RichTextEditor
